
const fittingRouter = [{
  path: 'apply',
  name: 'apply',
  component: resolve => require(['@views/fitting/apply'], resolve),
  meta: {
    title: '安装队申请',
    belong: 'fitting',
    
  }
},{
  path: 'record',
  name: 'record',
  component: resolve => require(['@views/fitting/record'], resolve),
  meta: {
    title: '项目记录',
    belong: 'fitting',
    
  }
},{
  path: 'detail',
  name: 'detail',
  component: resolve => require(['@views/fitting/detail'], resolve),
  meta: {
    title: '详情',
    belong: 'fitting',
    
  }
},{
  path: 'process',
  name: 'process',
  component: resolve => require(['@views/fitting/process'], resolve),
  meta: {
    title: '进度',
    belong: 'fitting',
    
  }
},{
  path: 'receive',
  name: 'receive',
  component: resolve => require(['@views/fitting/receive'], resolve),
  meta: {
    title: '收货',
    belong: 'fitting',
    
  }
},{
  path: 'role',
  name: 'role',
  component: resolve => require(['@views/fitting/role'], resolve),
  meta: {
    title: '选择登录方式',
    requireAuth: false
  }
},{
  path: 'login',
  name: 'fittingLogin',
  component: resolve => require(['@views/fitting/login'], resolve),
  meta: {
    title: '登录',
    requireAuth: false
  }
},{
  path: 'register',
  name: 'register',
  component: resolve => require(['@views/fitting/register'], resolve),
  meta: {
    title: '注册',
    requireAuth: false
  }
},{
  path: 'forgetpsw',
  name: 'forgetpsw',
  component: resolve => require(['@views/fitting/forgetPsw'], resolve),
  meta: {
    title: '忘记密码',
    requireAuth: false
  }
}]

export default fittingRouter;



// WEBPACK FOOTER //
// ./src/router/fitting/index.js